import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { InstitutionService } from '../../services/institution/institution.service';
import { map, catchError, of } from 'rxjs';
import { toast } from 'ngx-sonner';

export const institutionGuard: CanActivateFn = (route, state) => {
  const institutionService = inject(InstitutionService);
  const router = inject(Router);
  const uniqueId = route.paramMap.get('uniqueId');

  if (!uniqueId) {
    router.navigate(['/home']);
    return false;
  }

  return institutionService.find(uniqueId).pipe(
    map(institution => {
      if (institution) {
        return true;
      }
      toast.error('Institution not found');
      router.navigate(['/home']);
      return false;
    }),
    catchError(() => {
      toast.error('Failed to load institution');
      router.navigate(['/home']);
      return of(false);
    })
  );
};
